import { useSelector } from 'react-redux';
import { useLocation, matchPath } from 'react-router';

import getApplicationIdSelector from '/business/shared/state/selectors/application/getApplicationIdSelector';
import hasConfirmedTargetConfigurationSelector from '/business/shared/state/selectors/application/basket_meta/hasConfirmedTargetConfigurationSelector';
import getLatestPackageApplicationIdSelector from '/business/shared/state/selectors/application/model/getLatestPackageApplicationIdSelector';

import StyledReduceFooterNav from '/business/shared/components/pages/reduce/v3/nav/__styled__/StyledReduceFooterNav';
import ReduceFooterCard from '/business/shared/components/pages/reduce/v3/nav/ReduceFooterCard';

import { urlApplicationRoot } from '/business/shared/util/Statics';

import StyledBackground from '/business/shared/components/pages/__styled__/StyledBackground';

import nav, { type ReduceNavItem } from './nav';

const checkUrlMatch = (navItems: ReduceNavItem[], pathname: string) => {
  const isComparisonPage = matchPath(`/${urlApplicationRoot}/reduce/comparison`, pathname) !== null;

  // filters out the current page from the nav items
  const filteredNavItems = navItems.filter((navItem) => {
    const isMatch = matchPath(`/${urlApplicationRoot}/reduce/${navItem.url}`, pathname);
    const shouldHideHotspots = isComparisonPage && navItem.key === 'hotspots';
    return !isMatch && !shouldHideHotspots;
  });
  return filteredNavItems;
};

function ReduceFooterNav() {
  const applicationId = useSelector(getApplicationIdSelector);
  const latestPackageApplicationId = useSelector(getLatestPackageApplicationIdSelector);
  const hasConfirmedTargetConfiguration = useSelector(hasConfirmedTargetConfigurationSelector);

  const { pathname } = useLocation();

  const navKeys: ReduceNavItem['key'][] = ['hotspots', 'targets', 'initiatives', 'request', 'plan'];

  const filteredNavItems = checkUrlMatch(nav, pathname).filter((navItem) => navKeys.includes(navItem.key));

  if (!hasConfirmedTargetConfiguration) {
    return null;
  }

  return (
    <StyledReduceFooterNav>
      <StyledBackground backgroundColour="greyLight9" top={0} height="2rem" />
      {filteredNavItems.map((navItem) => {
        const navApplicationId = navItem.key === 'targets' ? latestPackageApplicationId : applicationId;
        return <ReduceFooterCard key={navItem.key} navItem={navItem} applicationId={navApplicationId} />;
      })}
    </StyledReduceFooterNav>
  );
}

export default ReduceFooterNav;
